<h3>Bookmarked flowers</h3>

<app-flower-box *ngFor='let fl of flowers; let i=index'
    [order]='i+1'
    [flower]='fl'>
</app-flower-box>
